import { useEffect, useState } from "react";
import { LocateFixed, Search, Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { STATES } from "@/lib/states";
import { useSearch } from "@/context/SearchContext";

export function SearchPanel() {
  const { searchGPS, searchCity, status, origin } = useSearch();
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const busy = status === "locating";
  useEffect(() => {
    if (origin) {
      setCity(origin.city);
      setState(origin.state);
    }
  }, [origin]);
  const submit = (e) => {
    e.preventDefault();
    if (city.trim() && state) searchCity(city.trim(), state);
  };
  return (
    <div className="panel p-4 sm:p-5">
      <div className="flex flex-col gap-3 lg:flex-row lg:items-center">
        <button
          data-testid="gps-location-button"
          onClick={searchGPS}
          disabled={busy}
          className="flex h-12 shrink-0 items-center justify-center gap-2 rounded-xl bg-[#fde68a] px-5 font-bold text-zinc-950 transition-transform hover:-translate-y-0.5 disabled:opacity-70"
        >
          {busy ? <Loader2 size={18} className="animate-spin" /> : <LocateFixed size={18} />}
          Use my location
        </button>
        <span className="text-center text-xs font-semibold uppercase tracking-widest text-zinc-500">or</span>
        <form onSubmit={submit} className="flex flex-1 flex-col gap-3 sm:flex-row">
          <Select value={state} onValueChange={setState}>
            <SelectTrigger data-testid="search-state-select" className="h-12 rounded-xl bg-zinc-950 sm:w-56">
              <SelectValue placeholder="State" />
            </SelectTrigger>
            <SelectContent className="max-h-72">
              {STATES.map(([c, n]) => <SelectItem key={c} value={c}>{n}</SelectItem>)}
            </SelectContent>
          </Select>
          <Input data-testid="search-city-input" value={city} onChange={(e) => setCity(e.target.value)} placeholder="City (e.g. Austin)" className="h-12 flex-1 rounded-xl bg-zinc-950" />
          <button data-testid="search-city-submit" type="submit" disabled={!city.trim() || !state} className="flex h-12 items-center justify-center gap-2 rounded-xl border border-[#fde68a]/60 px-5 font-bold text-[#fde68a] hover:bg-[#fde68a]/10 disabled:opacity-40">
            <Search size={17} /> Search
          </button>
        </form>
      </div>
      {origin && (
        <p data-testid="search-origin" className="mt-3 text-sm text-zinc-400">
          Showing happy hours within 60 miles of <span className="font-semibold text-zinc-200">{origin.city}, {origin.state}</span>
        </p>
      )}
    </div>
  );
}
